/**
 * @namespace countBodyInjectedInlineAds
 * @package ./countBodyInjectedInlineAds
 *
 * Used for the Index with Primary Article template, in order to properly
 * starts iterating inline ads in the Index block (Article, List Article)
 *
 * @param bodyInjected
 * @param {string} bodyBlockInlineAdDesktop
 * @param {string} bodyBlockInlineAdMobile
 * @returns {array} countInlineAds
 */
export const countBodyInjectedInlineAds = ({
  bodyInjected = null,
  bodyBlockInlineAdDesktop = 'DESKTOP_INLINE_ADVERT',
  bodyBlockInlineAdMobile = 'MOBILE_INLINE_ADVERT',
}) => {
  let countInlineAds = {
    countInlineAdsDesktop: 0,
    countInlineAdsMobile: 0,
  };

  if (bodyInjected && bodyInjected.length > 0) {
    bodyInjected.map((bodyBlock) => {
      if (bodyBlock.type === bodyBlockInlineAdDesktop) {
        countInlineAds.countInlineAdsDesktop += 1;
      }
      if (bodyBlock.type === bodyBlockInlineAdMobile) {
        countInlineAds.countInlineAdsMobile += 1;
      }
      countInlineAds = {
        countInlineAdsDesktop: countInlineAds.countInlineAdsDesktop,
        countInlineAdsMobile: countInlineAds.countInlineAdsMobile,
      };

      return countInlineAds;
    });
  }

  return countInlineAds;
};
